import { render, staticRenderFns } from "./FromShipmentPointSelect.vue?vue&type=template&id=37e99666&"
import script from "./FromShipmentPointSelect.vue?vue&type=script&lang=ts&"
export * from "./FromShipmentPointSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports